
const CheckedBoxSVG = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" transform="translate(0 0.000976562)" fill="#CC4466" />
    <path
      d="M30.6663 12.001L15.9997 26.6676L9.33301 20.001"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckedBoxSVG;